import { EventBus } from '../utils/EventBus.js';
import { serializeError } from '../utils/errors.js';

export class DiagnosticLogger {
    constructor({ maxEntries = 500 } = {}) {
        this.maxEntries = maxEntries;
        this.entries = [];
        this.events = new EventBus();
        this.throttles = new Map();
    }

    onEntry(listener) {
        return this.events.on('entry', listener);
    }

    debug(event, message, details = {}) {
        return this.add('debug', event, message, details);
    }

    info(event, message, details = {}) {
        return this.add('info', event, message, details);
    }

    warn(event, message, details = {}) {
        return this.add('warning', event, message, details);
    }

    error(event, message, error, details = {}) {
        return this.add('error', event, message, {
            ...details,
            error: serializeError(error),
        });
    }

    fatal(event, message, error, details = {}) {
        return this.add('fatal', event, message, {
            ...details,
            error: serializeError(error),
        });
    }

    debugThrottled(event, message, details = {}, intervalMs = 1000) {
        const timestamp = Date.now();
        const previous = this.throttles.get(event) || 0;

        if (timestamp - previous < intervalMs) {
            return null;
        }

        this.throttles.set(event, timestamp);

        return this.debug(event, message, details);
    }

    add(level, event, message, details = {}) {
        const entry = {
            timestamp: new Date().toISOString(),
            level,
            event,
            message,
            details,
        };

        this.entries.push(entry);

        if (this.entries.length > this.maxEntries) {
            this.entries.splice(0, this.entries.length - this.maxEntries);
        }

        this.events.emit('entry', entry);

        return entry;
    }

    getEntries() {
        return this.entries.map((entry) => ({
            ...entry,
            details: { ...entry.details },
        }));
    }

    clear() {
        this.entries = [];
        this.throttles.clear();
    }
}
